// src/data/headerData.ts
import { all_routes } from "../routes/all_routes";

export interface NavItem {
  id: string;
  title: string;
  path: string;
  badge?:boolean;
  icon?: string;
  isMegaMenu?: boolean;
  children?: NavItem[];
  className?: string;
  target?: string;
  relativeLinks?: string[]; // Array of paths that should keep this menu item active
}

export const headerNavData: NavItem[] = [
  {
    id: "home",
    title: "Home",
    path: all_routes.home,
    isMegaMenu: true,
    children: [
      {
        id: "home-1",
        title: "General Home 1",
        badge:false,
        path: all_routes.home,
        icon: "/assets/img/home/home.jpg",
      },
      {
        id: "home-2",
        title: "General Home 2",
        badge:false,
        path: all_routes.home2,
        icon: "/assets/img/home/home-01.jpg",
      },
      {
        id: "home-3",
        title: "Dental",
        badge:false,
        path: all_routes.home3,
        icon: "/assets/img/home/home-02.jpg",
      },
      {
        id: "home-4",
        title: "Pediatrics",
        badge:false,
        path: all_routes.home4,
        icon: "/assets/img/home/home-03.jpg",
      },
      {
        id: "home-5",
        title: "ENT",
        badge:false,
        path: all_routes.home5,
        icon: "/assets/img/home/home-04.jpg",
      },
      {
        id: "home-6",
        title: "Veterinary",
        badge:false,
        path: all_routes.home6,
        icon: "/assets/img/home/home-05.jpg",
      },
      {
        id: "home-7",
        title: "Cardiology",
        badge:false,
        path: all_routes.home7,
        icon: "/assets/img/home/home-06.jpg",
      },
      {
        id: "home-8",
        title: "Eye Care",
        badge:false,
        path: all_routes.home8,
        icon: "/assets/img/home/home-07.jpg",
      },
      {
        id: "home-9",
        title: "Home Care",
        badge:false,
        path: all_routes.home9,
        icon: "/assets/img/home/home-08.jpg",
      },
      {
        id: "home-10",
        title: "Fertility",
        badge:false,
        path: all_routes.home10,
        icon: "/assets/img/home/home-09.jpg",
      },
      {
        id: "home-11",
        title: "Cosmetic Surgery",
        badge:false,
        path: all_routes.home11,
        icon: "/assets/img/home/home-10.jpg",
      },
      {
        id: "home-12",
        title: "Laboratory",
        badge:false,
        path: all_routes.home12,
        icon: "/assets/img/home/home-11.jpg",
      },
      {
        id: "home-13",
        title: "Pharmacy",
        badge:false,
        path: all_routes.home13,
        icon: "/assets/img/home/home-12.jpg",
      },
      {
        id: "home-14",
        title: "Dermatology",
        badge:false,
        path: all_routes.home14,
        icon: "/assets/img/home/home-14.jpg",
      },
      {
        id: "home-15",
        title: "Mental Health",
        badge:false,
        path: all_routes.home15,
        icon: "/assets/img/home/home-15.jpg",
      },
      {
        id: "home-16",
        badge:true,
        title: "Nutrition",
        path: all_routes.home16,
        icon: "/assets/img/home/home-18.jpg",
      },
      {
        id: "home-17",
        badge:true,
        title: "Healing & Wellness",
        path: all_routes.home17,
        icon: "/assets/img/home/home-19.jpg",
      },
      {
        id: "home-18",
        badge:true,
        title: "Physiotherapy",
        path: all_routes.home18,
        icon: "/assets/img/home/home-17.jpg",
      },
    ],
  },
  {
    id: "doctors",
    title: "Doctors",
    path: all_routes.doctorDashboard,
    children: [
      {
        id: "doctor-dashboard",
        title: "Doctor Dashboard",
        path: all_routes.doctorDashboard,
          relativeLinks: [
          all_routes.doctorSpecialities,
        ], // Add relative links here
      },
      {
        id: "appointments",
        title: "Appointments",
        path: all_routes.doctorAppointments,
        relativeLinks: [
          all_routes.doctorRequest,
          all_routes.doctorAppointmentsGrid,
          all_routes.doctorUpcomingAppointment,
          all_routes.doctorAppointmentsStart,
        ], // Add relative links here
      },
      {
        id: "available-timings",
        title: "Available Timing",
        path: all_routes.doctorAvailableTimings,
      },
      {
        id: "patients-list",
        title: "Patients List",
        path: all_routes.doctorMypatients,
      },
      { id: "chat-doctor", title: "Chat", path: all_routes.doctorChat },
      { id: "invoices", title: "Invoices", path: all_routes.doctorInvoices },
      {
        id: "profile-settings",
        title: "Profile Settings",
        path: all_routes.doctorProfileSettings,
         relativeLinks: [
      all_routes.doctorEducationSettings,
      all_routes.doctorExperienceSettings,
      all_routes.doctorAwardsSettings,
      all_routes.doctorInsuranceSettings,
      all_routes.doctorClinicsSettings,
      all_routes.doctorBusinessSettings,
    ],
      },
    ],
  },
  {
    id: "patients",
    title: "Patients",
    path: all_routes.patientDashboard,
    children: [
      {
        id: "patient-dashboard",
        title: "Patient Dashboard",
        path: all_routes.patientDashboard,
      },
      {
        id: "doctors-grid",
        title: "Doctors Grid",
        path: all_routes.doctorsGrid,
      },
      {
        id: "doctors-list",
        title: "Doctors List",
        path: all_routes.doctorsList,
      },
      {
        id: "doctors-availability",
        title: "Doctors Availability",
        path: all_routes.doctorsAvailability,
      },
      { id: "booking", title: "Booking", path: all_routes.booking },
      { id: "booking-1", title: "Booking 1", path: all_routes.booking1 },
      { id: "booking-2", title: "Booking 2", path: all_routes.booking2 },
      {
        id: "booking-popup",
        title: "Booking Popup",
        path: all_routes.bookingPopup,
      },
      {
        id: "search-doctor-1",
        title: "Search Doctor 1",
        path: all_routes.search1,
      },
      {
        id: "search-doctor-2",
        title: "Search Doctor 2",
        path: all_routes.search2,
      },
      {
        id: "doctor-profile-1",
        title: "Doctor Profile 1",
        path: all_routes.doctorProfile1,
      },
      {
        id: "doctor-profile-2",
        title: "Doctor Profile 2",
        path: all_routes.doctorProfile2,
      },
      { id: "checkout", title: "Checkout", path: all_routes.checkout },
      { id: "favorites", title: "Favourites", path: all_routes.favourites },
      { id: "patient-chat", title: "Chat", path: all_routes.chat },
      {
        id: "patient-profile-settings",
        title: "Profile Settings",
        path: all_routes.patientProfileSettings,
      },
    ],
  },
  {
    id: "pharmacy",
    title: "Pharmacy",
    path: all_routes.pharmacyIndex,
    children: [
      {
        id: "pharmacy-index",
        title: "Pharmacy",
        path: all_routes.pharmacyIndex,
      },
      {
        id: "pharmacy-details",
        title: "Pharmacy Details",
        path: all_routes.pharmacyDetails,
      },
      {
        id: "pharmacy-search",
        title: "Pharmacy Search",
        path: all_routes.pharmacySearch,
      },
      { id: "products", title: "Products", path: all_routes.productAll },
      {
        id: "product-details",
        title: "Product Description",
        path: all_routes.productDescription,
      },
      { id: "cart", title: "Cart", path: all_routes.cart },
      {
        id: "pharmacy-checkout",
        title: "Checkout",
        path: all_routes.productCheckout,
      },
      {
        id: "payment-success",
        title: "Payment Success",
        path: all_routes.paymentSuccess,
      },
      {
        id: "pharmacy-register",
        title: "Pharmacy Register",
        path: all_routes.pharmacyRegister,
      },
    ],
  },
  {
    id: "pages",
    title: "Pages",
    path: all_routes.aboutUs,
    isMegaMenu: true,
    children: [
      // Column 1
      { id: "about-us", title: "About Us", path: all_routes.aboutUs },
      { id: "contact-us", title: "Contact Us", path: all_routes.contactUs },
      { id: "hospitals", title: "Hospitals", path: all_routes.hospitals },
      { id: "speciality", title: "Speciality", path: all_routes.speciality },
      { id: "clinic", title: "Clinic", path: all_routes.clinics },
      {
        id: "starter-page",
        title: "Starter Page",
        path: all_routes.starterPage,
      },
      { id: "pricing", title: "Pricing Plan", path: all_routes.pricing },
      { id: "faq", title: "FAQ", path: all_routes.faq },

      // Column 2
      { id: "login-email", title: "Login Email", path: all_routes.loginEmail },
      { id: "login-phone", title: "Login Phone", path: all_routes.loginPhone },
      {
        id: "doctor-signup",
        title: "Doctor Signup",
        path: all_routes.doctorSignup,
      },
      {
        id: "patient-signup",
        title: "Patient Signup",
        path: all_routes.patientSignup,
      },
      {
        id: "forgot-password-1",
        title: "Forgot Password 1",
        path: all_routes.forgotPassword1,
      },
      {
        id: "forgot-password-2",
        title: "Forgot Password 2",
        path: all_routes.forgotPassword2,
      },
      { id: "email-otp", title: "Email OTP", path: all_routes.loginEmailOtp },
      { id: "phone-otp", title: "Phone OTP", path: all_routes.loginPhoneOtp },

      // Column 3
      { id: "maintenance", title: "Maintenance", path: all_routes.maintenance },
      { id: "coming-soon", title: "Coming Soon", path: all_routes.comingSoon },
      {
        id: "terms",
        title: "Terms & Conditions",
        path: all_routes.termsAndCondition,
      },
      {
        id: "privacy",
        title: "Privacy Policy",
        path: all_routes.privacyPolicy,
      },
      { id: "components", title: "Components", path: all_routes.components },
      { id: "invoices", title: "Invoices", path: all_routes.invoiceList },
      {
        id: "invoice-view",
        title: "Invoice View",
        path: all_routes.invoiceView,
      },

      // Column 4
      { id: "voice-call", title: "Voice Call", path: all_routes.voiceCall },
      { id: "video-call", title: "Video Call", path: all_routes.videoCall },
      { id: "error-404", title: "404 Error", path: all_routes.error404 },
      { id: "error-500", title: "500 Error", path: all_routes.error500 },
    ],
  },
  {
    id: "blog",
    title: "Blog",
    path: all_routes.blogList,
    children: [
      { id: "blog-list", title: "Blog List", path: all_routes.blogList },
      { id: "blog-grid", title: "Blog Grid", path: all_routes.blogGrid },
      {
        id: "blog-details",
        title: "Blog Details",
        path: all_routes.blogDetails,
      },
    ],
  },
  {
    id: "admin",
    title: "Admin",
    path: all_routes.admin,
    children: [
      {
        id: "admin-dashboard",
        title: "Admin",
        path: "https://doccure.dreamstechnologies.com/react/template/admin/admin-dashboard",
        target: "_blank",
      },
      {
        id: "pharmacy-admin",
        title: "Pharmacy Admin",
        path: "https://doccure.dreamstechnologies.com/react/template/pharmacy/pharmacyadmin",
        target: "_blank",
      },
    ],
  },
];
